export interface GenericBulkUpsertRecord {
  rowIndex: number;
  action?: GenericBulkUpsertAction;
  [key: string]: any;
}

export enum GenericBulkUpsertAction {
  Create = 0,
  Update = 1,
  NoChange = 2
}

export interface GenericValidationError {
  rowIndex: number;
  field: string;
  errorMessage: string;
}

export interface GenericFieldChange {
  rowIndex: number;
  field: string;
  oldValue: string;
  newValue: string;
}

export interface GenericRemovedItem {
  key: string;
  description: string;
}

export interface GenericValidateResponse {
  hasErrors: boolean;
  records: GenericBulkUpsertRecord[];
  errors: GenericValidationError[];
  changes: GenericFieldChange[];
  removed: GenericRemovedItem[];
}

export interface GenericUploadResponse {
  records: GenericBulkUpsertRecord[];
  changes: GenericFieldChange[];
  removed: GenericRemovedItem[];
}

export interface GenericBulkUpsertField {
  key: string;
  label: string;
}